export default ['received', 'clicked']
